export default __webpack_public_path__ + "static/fig1-b4c3608882416a61d9b7fe4e71c6fd36.png";